(() => {
  const featuredEl = document.querySelector(".featured-companies");
  if (!featuredEl) return;

  const href = window.location.href.toLowerCase();
  const isWomen =
    href.includes("women") ||
    href.includes("woman") ||
    (typeof getCookie === "function" &&
      getCookie("personalize") === "women" &&
      window.location.pathname === "/");

  const activeGender = isWomen ? "women" : "men";
  const hiddenGender = isWomen ? "men" : "women";

  featuredEl.dataset.activeGender = activeGender;

  const activeContainer = document.querySelector(`.featured-companies__container-${activeGender}`);
  const hiddenContainer = document.querySelector(`.featured-companies__container-${hiddenGender}`);

  activeContainer?.classList.remove("hidden");
  hiddenContainer?.classList.add("hidden");

  activeContainer?.classList.remove("loading");
  hiddenContainer?.classList.remove("loading");

  const quotesEl = document.querySelector(`#featured-companies__quotes--slider-${activeGender}`);
  const thumbsEl = document.querySelector(`#featured-company__thumbnails--slider-${activeGender}`);

  if (!quotesEl || !thumbsEl) return;
  if (typeof KeenSlider !== "function") return;

  const waitForWidth = (el, cb, tries = 0) => {
    const w = el.getBoundingClientRect().width;
    if (w > 0) {
      cb();
      return;
    }
    if (tries > 60) return;
    requestAnimationFrame(() => waitForWidth(el, cb, tries + 1));
  };

  const autoplay = (s) => {
    let timeout;
    let mouseOver = false;

    const clearNextTimeout = () => clearTimeout(timeout);
    const nextTimeout = () => {
      clearTimeout(timeout);
      if (mouseOver) return;
      timeout = setTimeout(() => s.next(), 5000);
    };

    s.on("created", () => {
      s.container.addEventListener("mouseover", () => {
        mouseOver = true;
        clearNextTimeout();
      });

      s.container.addEventListener("mouseout", () => {
        mouseOver = false;
        nextTimeout();
      });

      nextTimeout();
    });

    s.on("dragStarted", clearNextTimeout);
    s.on("animationEnded", nextTimeout);
    s.on("updated", nextTimeout);
  };

  let slider = null;
  let thumbnails = null;

  const init = () => {
    if (slider) slider.destroy();
    if (thumbnails) thumbnails.destroy();

    slider = new KeenSlider(
      quotesEl,
      { loop: true },
      [typeof navigation === "function" ? navigation : () => {}, autoplay]
    );

    thumbnails = new KeenSlider(
      thumbsEl,
      {
        initial: 0,
        slides: { perView: 5, spacing: 10 },
        breakpoints: {
          "(max-width: 449px)": { slides: { perView: 2.5, spacing: 10, origin: "center" } },
          "(min-width: 450px) and (max-width: 749px)": { slides: { perView: 3.5, spacing: 10, origin: "center" } },
          "(min-width: 750px)": { slides: { perView: 5, spacing: 10 } },
        },
      }
    );

    // Make slides visible before KeenSlider measures them
    document
      .querySelectorAll(
        `.featured-companies__container-${activeGender} .featured-company__thumbnails .keen-slider__slide`
      )
      .forEach((el) => (el.style.display = "block"));

    // Force KeenSlider to remeasure now that slides are visible
    thumbnails.update();

    const setActiveThumb = (rel) => {
      thumbnails.slides.forEach((s) => s.classList.remove("active"));
      if (thumbnails.slides[rel]) thumbnails.slides[rel].classList.add("active");
      thumbnails.moveToIdx(rel);
    };

    // Click on thumbnail → move quotes slider
    thumbnails.slides.forEach((slide, idx) => {
      slide.addEventListener("click", () => {
        slider.moveToIdx(idx);
      });
    });

    // Initialise active state — set after update so dimensions are correct
    setActiveThumb(0);

    // main → thumbnails sync
    slider.on("animationStarted", (s) => {
      const next = s.animator.targetIdx || 0;
      const rel = s.track.absToRel(next);
      setActiveThumb(rel);
    });

    // thumbnails swipe → main sync
    let isThumbDrag = false;
    thumbnails.on("dragStarted", () => { isThumbDrag = true; });
    thumbnails.on("animationEnded", () => {
      if (!isThumbDrag) return;
      isThumbDrag = false;
      slider.moveToIdx(thumbnails.track.details.rel);
    });

    requestAnimationFrame(() => {
      slider.update();
      thumbnails.update();
    });
  };

  waitForWidth(activeContainer || featuredEl, init);

  const updateAll = () => {
    if (!slider || !thumbnails) return;
    slider.update();
    thumbnails.update();
  };

  let raf;
  window.addEventListener("resize", () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(updateAll);
  });

  window.addEventListener("orientationchange", updateAll);

  const ro = new ResizeObserver(updateAll);
  ro.observe(activeContainer || featuredEl);

  window.addEventListener("load", updateAll);
})();
